import _request from '../lib/request'
import NavigationService from '../services/navigation'
import Constants from 'expo-constants'

const getHost = (environment) => {
  const env = environment || Constants.manifest.extra.environment
  switch (env) {
    case 'test': {
      return 'https://test-admin-api.banksim.co'
    }
    case 'development': {
      return 'http://localhost:9000'
    }
    default: {
      return 'https://admin-api.banksim.co'
    }
  }
}

class AdminAPI {
  async request (opts) {
    if (opts.funcName !== 'Login') {
      if (this.token) {
        opts.headers = { Authorization: `Bearer ${this.token}` }
      }
    }
    try {
      const result = await _request(opts)
      return result
    } catch (e) {
      if (opts.funcName !== 'Login' && (e.code === 401 || e.code === 403)) {
        NavigationService.doLogout()
        throw e
      }
      throw e
    }
  }

  setToken (token) {
    this.token = token
  }

  async getEvents ({ environment, email }) {
    return this.request({ url: `${getHost(environment)}/api/participants/${email}/events`, funcName: 'Get Participant Events' })
  }

  async getParticipantDetails ({ participantId, environment, eventId }) {
    return this.request({ url: `${getHost(environment)}/api/events/${eventId}/participants/${participantId}/details`, funcName: 'Get Participant Summary' })
  }

  async getParticipants ({ teamId, environment, eventId }) {
    return this.request({ url: `${getHost(environment)}/api/events/${eventId}/teams/${teamId}/participants`, funcName: 'Get Participants on your team' })
  }

  async login ({ environment, eventId, email, password }) {
    return this.request({
      isPublic: true,
      method: 'POST',
      url: `${getHost(environment)}/api/events/${eventId}/login`,
      body: {
        email, password
      },
      funcName: 'Login'
    })
  }

  async getResources ({ participantId, environment, eventId }) {
    return this.request({
      url: `${getHost(environment)}/api/events/${eventId}/participants/${participantId}/resources`,
      funcName: 'get resources'
    })
  }

  async getStatus () {
    return this.request({
      method: 'GET',
      url: `${getHost()}/api/status`
    })
  }
}

export default new AdminAPI()
